mutation Inertia_CreateOrder($companyId: ID!, $officerId: ID, $description: String, $externalFileNumber: String, $verificationEnabled: Boolean, $documentEmailEnabled: Boolean) {
  createOrder(input: { companyId: $companyId, officerId: $officerId, description: $description, externalFileNumber: $externalFileNumber, verificationEnabled: $verificationEnabled, documentEmailEnabled: $documentEmailEnabled }) {
    order {
      id
      gid
    }
    errors
  }
}